import _ from 'lodash';
import moment from 'moment';
import { mathjax } from 'mathjax-full/js/mathjax.js';
import { TeX } from 'mathjax-full/js/input/tex.js';
import { SVG } from 'mathjax-full/js/output/svg.js';
import { liteAdaptor } from 'mathjax-full/js/adaptors/liteAdaptor.js';
import { RegisterHTMLHandler } from 'mathjax-full/js/handlers/html.js';
import { AllPackages  } from 'mathjax-full/js/input/tex/AllPackages.js';

/***************************
 * userの権限
 ***************************/
export enum RoleEnum {
  Admin = "admin",
  Teacher = "teacher",
  Student = "student"
}

export enum RoleNameEnum {
  Admin = "管理者",
  Teacher = "先生",
  Student = "生徒"
}

export interface ComboboxRole {
  value: string
  text: string
}

// プルダウン・ラジオボタン用
export function GetComboboxRoleArray() :ComboboxRole[]{
  const rtn: ComboboxRole[] = [];
  rtn.push({value: RoleEnum.Admin, text: RoleNameEnum.Admin});
  rtn.push({value: RoleEnum.Teacher, text: RoleNameEnum.Teacher});
  return rtn;
}

/***************************
 * 学年
 ***************************/
export enum GradeEnum {
  Chu1 = 1,
  Chu2 = 2,
  Chu3 = 3,
  Kou1 = 4,
  Kou2 = 5,
  Kou3 = 6
}

export enum GradeNameEnum {
  Chu1 = "中1",
  Chu2 = "中2",
  Chu3 = "中3",
  Kou1 = "高1",
  Kou2 = "高2",
  Kou3 = "高3"
}

export interface ComoboxGrade {
  value: number
  text: string
}

export function GetComboboxGradeArray() :ComoboxGrade[] {
  const rtn: ComoboxGrade[] = [];
  rtn.push({value: GradeEnum.Chu1, text: GradeNameEnum.Chu1});
  rtn.push({value: GradeEnum.Chu2, text: GradeNameEnum.Chu2});
  rtn.push({value: GradeEnum.Chu3, text: GradeNameEnum.Chu3});
  rtn.push({value: GradeEnum.Kou1, text: GradeNameEnum.Kou1});
  rtn.push({value: GradeEnum.Kou2, text: GradeNameEnum.Kou2});
  rtn.push({value: GradeEnum.Kou3, text: GradeNameEnum.Kou3});
  return rtn;
}

export function GetGradeNameByGrade(grade: number) :string {
  if(grade == GradeEnum.Chu1){
    return GradeNameEnum.Chu1;
  }else if(grade == GradeEnum.Chu2){
    return GradeNameEnum.Chu2;
  }else if(grade == GradeEnum.Chu3){
    return GradeNameEnum.Chu3;
  }else if(grade == GradeEnum.Kou1){
    return GradeNameEnum.Kou1;
  }else if(grade == GradeEnum.Kou2){
    return GradeNameEnum.Kou2;
  }else if(grade == GradeEnum.Kou3){
    return GradeNameEnum.Kou3;
  }else{
    return "";
  }
}

/***************************
 * 実施月 プルダウン用
 ***************************/
export interface ComoboxMonth {
  value: number
  text: string
}

export function GetComboboxMonthArray() :ComoboxMonth[] {
  const rtn: ComoboxMonth[] = [];
  rtn.push({value: 1, text: "1月"});
  rtn.push({value: 2, text: "2月"});
  rtn.push({value: 3, text: "3月"});
  rtn.push({value: 4, text: "4月"});
  rtn.push({value: 5, text: "5月"});
  rtn.push({value: 6, text: "6月"});
  rtn.push({value: 7, text: "7月"});
  rtn.push({value: 8, text: "8月"});
  rtn.push({value: 9, text: "9月"});
  rtn.push({value: 10, text: "10月"});
  rtn.push({value: 11, text: "11月"});
  rtn.push({value: 12, text: "12月"});
  return rtn;
}

/***************************
 * 試験種
 ***************************/
export enum KindEnum {
  TwentyMin = 10,
  Various = 20,
  Kimatsu = 30
}

export enum KindNameEnum {
  TwentyMin = "20分テスト",
  Various = "諸テスト",
  Kimatsu = "期末テスト"
}

/***************************
 * 試験種 プルダウン用
 ***************************/
export interface ComoboxKind {
  value: number
  text: string
}

export function GetComboboxKindArray() :ComoboxKind[] {
  const rtn: ComoboxKind[] = [];
  rtn.push({value: KindEnum.TwentyMin, text: KindNameEnum.TwentyMin});
  rtn.push({value: KindEnum.Various, text: KindNameEnum.Various});
  rtn.push({value: KindEnum.Kimatsu, text: KindNameEnum.Kimatsu});
  return rtn;
}

export function GetKindNameByKind(kind: number) :string {
  if(kind == KindEnum.TwentyMin){
    return KindNameEnum.TwentyMin;
  }else if(kind == KindEnum.Various){
    return KindNameEnum.Various;
  }else if(kind == KindEnum.Kimatsu){
    return KindNameEnum.Kimatsu;
  }else{
    return "";
  }
}

/***************************
 * 学校ごとに付与されるオプション情報
 ***************************/
export enum SchoolOptionEnum {
  StudentManage = 1,
  Cbt = 2,
  Entrance = 3,
  TwoFactor = 4,
  Classroom = 5,
}

/***************************
 * 試験種別
 ***************************/
export enum SheetTypeEnum {
  Normal = 0,
  Cbt = 1,
  Entrance = 2,
}

/***************************
 * API連携種別Api
 ***************************/
export enum ApiTypeEnum {
  None = 0,
  Classroom = 1,
  Teams = 2,
}

/***************************
 * sheet_field.kind Enum
 * api側のConstantsと同じ定義にすること
 ***************************/
export enum SheetFieldKindEnum {
  FIELD = 0,
  TOTAL_SCORE = 10,
  PART1 = 11,
  VIEW_POINT = 12,
  STUDENT_INFO = 9,
}

/***************************
 * 正答 プルダウン用
 ***************************/
 export interface ComoboxCorrectText {
  value: string
  text: string
}

export function GetComboboxCorrectTextArray() :ComoboxCorrectText[] {
  const rtn: ComoboxCorrectText[] = [];
  rtn.push({value: "ア", text: "ア"});
  rtn.push({value: "イ", text: "イ"});
  rtn.push({value: "ウ", text: "ウ"});
  rtn.push({value: "エ", text: "エ"});
  rtn.push({value: "オ", text: "オ"});
  rtn.push({value: "カ", text: "カ"});
  rtn.push({value: "キ", text: "キ"});
  rtn.push({value: "ク", text: "ク"});
  rtn.push({value: "ケ", text: "ケ"});
  rtn.push({value: "コ", text: "コ"});
  rtn.push({value: "0", text: "0"});
  rtn.push({value: "1", text: "1"});
  rtn.push({value: "2", text: "2"});
  rtn.push({value: "3", text: "3"});
  rtn.push({value: "4", text: "4"});
  rtn.push({value: "5", text: "5"});
  rtn.push({value: "6", text: "6"});
  rtn.push({value: "7", text: "7"});
  rtn.push({value: "8", text: "8"});
  rtn.push({value: "9", text: "9"});
  return rtn;
}

/***************************
 * field_activity.correct_state Enum
 ***************************/
export enum CorrectStateEnum {
  Seitou = 1,
  Gotou = -1,
  Tokuten = 0
}

/***************************
 * sheet_field.scoring_type Enum
 * api側のConstantsと同じ定義にすること
 ***************************/
 export enum ScoringTypeEnum {
  Seigo = 1,
  ScoreStampPlus = 2,
  ScoreStampMinus = 3,
}

/***************************
 * scoring_type プルダウン用
 ***************************/
 export interface ComoboxScoingType {
  value: number
  text: string
}

export function GetComboboxScoingTypeArray() :ComoboxScoingType[] {
  const rtn: ComoboxScoingType[] = [];
  rtn.push({value: ScoringTypeEnum.Seigo, text: GetScoringTypeNameByCode(ScoringTypeEnum.Seigo)});
  rtn.push({value: ScoringTypeEnum.ScoreStampPlus, text: GetScoringTypeNameByCode(ScoringTypeEnum.ScoreStampPlus)});
  rtn.push({value: ScoringTypeEnum.ScoreStampMinus, text: GetScoringTypeNameByCode(ScoringTypeEnum.ScoreStampMinus)});
  return rtn;
}

export function IsScoringTypeScoreStamp(scoring_type: number) :boolean {
  return scoring_type == ScoringTypeEnum.ScoreStampPlus || scoring_type == ScoringTypeEnum.ScoreStampMinus
}

export function GetScoringTypeNameByCode(code: number){
  let rtn = "";
  if(code == ScoringTypeEnum.Seigo){
    rtn = "正誤";
  }else if(code == ScoringTypeEnum.ScoreStampPlus){
    rtn = "加点スタンプ";
  }else if(code == ScoringTypeEnum.ScoreStampMinus){
    rtn = "減点スタンプ";
  }
  return rtn;
}

/***************************
 * API Getのクエリ生成
 ***************************/
export function BuildQuery(object: any, namespace: string) :string {
  return _.map(object, (value: any, key: any) => {
    return namespace ? `${namespace}[${encodeURIComponent(key)}]=${encodeURIComponent(value)}` : `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
  }).join('&');
}

/***************************
 * 時刻を指定されたフォーマットに変換
 ***************************/
export function formatDate(value: any, format: string) :string {
  if (value === null || value === "") {
    return "";
  }
  var datetimeAt = new Date(value);
  return moment(datetimeAt).format(format);
}

/***************************
 * 数字配列の合計値を取得
 ***************************/
export function sumArray(array: number[]) {
  let sum = 0;
  for (let i = 0, len = array.length; i < len; i++) {
    sum += array[i];
  }
  return sum;
}

/***************************
 * 試験一覧のページあたりの行数
 ***************************/
export const SheetListRowCount = 20;

/***************************
 * 生徒一覧のページあたりの行数
 ***************************/
export const StudentListRowCount = 50;

/***************************
 * 教師一覧のページあたりの行数
 ***************************/
export const TeacherListRowCount = 50;

/***************************
 * アニメーションありのスクロール
 ***************************/
export function smoothScroll(fromPos: number, toPos: number, elem: HTMLElement) {

  let scrollTop = fromPos;
  const range = (toPos - fromPos) / 20;
  var move = function () { // 実際にスクロールを行う
    
    if((range > 0 && scrollTop + range > toPos) || (range < 0 && scrollTop + range < toPos)){
      scrollTop = toPos;
    }else{
      scrollTop += range
    }
    elem.scrollTo(0, scrollTop); // スクロールさせる

    // 現在位置が目的位置より進んでいなければアニメーションを続行させる
    if ((range > 0 && scrollTop < toPos) || (range < 0 && scrollTop > toPos)) {
        requestAnimationFrame(move);
    }
  };

  requestAnimationFrame(move); // 初回呼び出し
}

/**
 * 整数チェック
 * @param value 
 */
export const isInteger = (value: string): boolean => {

  if (!value) {
    return false;
  }

  const number = Number(value);

  return !isNaN(number) && isFinite(number) && (value.toString().length == parseInt(value).toString().length) && (value.toString().indexOf(".") == -1);
}

/**
 * 文字列と文字列を繋げる.
 * @param base 基になる文字列
 * @param join 繋げる文字列
 * @param connection 区切り文字
 */
export const stringConnection = (base: string, join: string, connection: string) : string => {

	var str = null;
	if (base == null || base == "") {
		str = join;
	} else {
		str = base + connection + join;
	}
	return str;
}

const adaptor = liteAdaptor();
RegisterHTMLHandler(adaptor);
const tex = new TeX({packages: AllPackages});
const svg = new SVG({fontCache: 'none'});
const mathDocument = mathjax.document('', {InputJax: tex, OutputJax: svg});

export const convertSvgElementByLaTex = (laTex: string): string => {
  const node = mathDocument.convert(laTex, {display: true});
  return adaptor.outerHTML(node);
};

/***************************
 * 文字認識の種別 Enum
 ***************************/
export enum RecogTypeEnum {
  SingleNumber = 1,
  SingleAlpha = 2,
  SingleKana = 3,
  SingleHira = 4,
  SingleKanNumber = 5,
  SingleYesNo = 6,
  EnglishWord = 7,
  EnglishSentence = 8,
  Math = 9,
}

export interface ComoboxRecogType {
  value: number
  text: string
}

export function GetComboboxRecogTypeArray() :ComoboxRecogType[] {
  const rtn: ComoboxRecogType[] = [];
  rtn.push({value: RecogTypeEnum.SingleNumber, text: GetRecogTypeNameByCode(RecogTypeEnum.SingleNumber)});
  rtn.push({value: RecogTypeEnum.SingleAlpha, text: GetRecogTypeNameByCode(RecogTypeEnum.SingleAlpha)});
  rtn.push({value: RecogTypeEnum.SingleKana, text: GetRecogTypeNameByCode(RecogTypeEnum.SingleKana)});
  rtn.push({value: RecogTypeEnum.SingleHira, text: GetRecogTypeNameByCode(RecogTypeEnum.SingleHira)});
  rtn.push({value: RecogTypeEnum.SingleKanNumber, text: GetRecogTypeNameByCode(RecogTypeEnum.SingleKanNumber)});
  rtn.push({value: RecogTypeEnum.SingleYesNo, text: GetRecogTypeNameByCode(RecogTypeEnum.SingleYesNo)});
  rtn.push({value: RecogTypeEnum.EnglishWord, text: GetRecogTypeNameByCode(RecogTypeEnum.EnglishWord)});
  // rtn.push({value: RecogTypeEnum.EnglishSentence, text: GetRecogTypeNameByCode(RecogTypeEnum.EnglishSentence)});
  rtn.push({value: RecogTypeEnum.Math, text: GetRecogTypeNameByCode(RecogTypeEnum.Math)});
  return rtn;
}

export function GetRecogTypeNameByCode(code: number){
  let rtn = "";
  if(code == RecogTypeEnum.SingleNumber){
    rtn = "数字1文字（0～9）";
  }else if(code == RecogTypeEnum.SingleAlpha){
    rtn = "アルファベット1文字（A～F, a～f）";
  }else if(code == RecogTypeEnum.SingleKana){
    rtn = "カタカナ1文字（ア～チ）";
  }else if(code == RecogTypeEnum.SingleHira){
    rtn = "ひらがな1文字（あ～こ）";
  }else if(code == RecogTypeEnum.SingleKanNumber){
    rtn = "漢数字1文字（一～九）";
  }else if(code == RecogTypeEnum.SingleYesNo){
    rtn = "マルバツ1文字（○・×）";
  }else if(code == RecogTypeEnum.EnglishWord){
    rtn = "英単語";
  }else if(code == RecogTypeEnum.EnglishSentence){
    rtn = "英文";
  }else if(code == RecogTypeEnum.Math){
    rtn = "数式";
  }
  return rtn;
}

export function IsSingleCharRecog(code: number){
  return [RecogTypeEnum.SingleNumber, RecogTypeEnum.SingleAlpha, RecogTypeEnum.SingleKana, RecogTypeEnum.SingleHira, RecogTypeEnum.SingleKanNumber, RecogTypeEnum.SingleYesNo].includes(code);
}

export interface ComoboxRecogChar {
  value: number
  text: string
}

export function GetComboboxRecogCharArray(recog_type: number){
  let rtn: ComoboxRecogChar[] = [];
  
  if(recog_type == RecogTypeEnum.SingleNumber){
    rtn.push({value: 0, text: "0"});
    rtn.push({value: 1, text: "1"});
    rtn.push({value: 2, text: "2"});
    rtn.push({value: 3, text: "3"});
    rtn.push({value: 4, text: "4"});
    rtn.push({value: 5, text: "5"});
    rtn.push({value: 6, text: "6"});
    rtn.push({value: 7, text: "7"});
    rtn.push({value: 8, text: "8"});
    rtn.push({value: 9, text: "9"});
  }else if(recog_type == RecogTypeEnum.SingleAlpha){
    rtn.push({value: 0, text: "Aa"});
    rtn.push({value: 1, text: "Bb"});
    rtn.push({value: 2, text: "Cc"});
    rtn.push({value: 3, text: "Dd"});
    rtn.push({value: 4, text: "Ee"});
    rtn.push({value: 5, text: "Ff"});
  }else if(recog_type == RecogTypeEnum.SingleKana){
    rtn.push({value: 0, text: "ア"});
    rtn.push({value: 1, text: "イ"});
    rtn.push({value: 2, text: "ウ"});
    rtn.push({value: 3, text: "エ"});
    rtn.push({value: 4, text: "オ"});
    rtn.push({value: 5, text: "カ"});
    rtn.push({value: 6, text: "キ"});
    rtn.push({value: 7, text: "ク"});
    rtn.push({value: 8, text: "ケ"});
    rtn.push({value: 9, text: "コ"});
    rtn.push({value: 10, text: "サ"});
    rtn.push({value: 11, text: "シ"});
    rtn.push({value: 12, text: "ス"});
    rtn.push({value: 13, text: "セ"});
    rtn.push({value: 14, text: "ソ"});
    rtn.push({value: 15, text: "タ"});
    rtn.push({value: 16, text: "チ"});
  }else if(recog_type == RecogTypeEnum.SingleHira){
    rtn.push({value: 0, text: "あ"});
    rtn.push({value: 1, text: "い"});
    rtn.push({value: 2, text: "う"});
    rtn.push({value: 3, text: "え"});
    rtn.push({value: 4, text: "お"});
    rtn.push({value: 5, text: "か"});
    rtn.push({value: 6, text: "き"});
    rtn.push({value: 7, text: "く"});
    rtn.push({value: 8, text: "け"});
    rtn.push({value: 9, text: "こ"});
  }else if(recog_type == RecogTypeEnum.SingleKanNumber){
    rtn.push({value: 0, text: "二"});
    rtn.push({value: 1, text: "三"});
    rtn.push({value: 2, text: "四"});
    rtn.push({value: 3, text: "五"});
    rtn.push({value: 4, text: "六"});
    rtn.push({value: 5, text: "七"});
    rtn.push({value: 6, text: "八"});
    rtn.push({value: 7, text: "九"});
  }else if(recog_type == RecogTypeEnum.SingleYesNo){
    rtn.push({value: 0, text: "o"});
    rtn.push({value: 1, text: "x"});
  }

  return rtn;
}

export const getCorrectText = (recog_type: number, text: string) => {
  if(text != null && recog_type == RecogTypeEnum.SingleAlpha){
    if(["A", "a"].includes(text)){
      return "Aa";
    }else if(["B", "b"].includes(text)){
      return "Bb";
    }else if(["C", "c"].includes(text)){
      return "Cc";
    }else if(["D", "d"].includes(text)){
      return "Dd";
    }else if(["E", "e"].includes(text)){
      return "Ee";
    }else if(["F", "f"].includes(text)){
      return "Ff";
    }
  }else{
    return text;
  }
}